import PropTypes from "prop-types";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit-010.svg";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus1.svg";
import styled from "styled-components";

const StyledBOStageXCards = styled.div`
    &.ui-card-style-01-m {
        max-width: 335px;
        height: 193px;
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 24px 12px 24px 12px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        //align-self: stretch;
        flex: 1;
        position: relative;
        justify-content: center;
    }
    .frame-1000011380 {
        padding: 0px 32px 0px 32px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .get {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 42px;
        letter-spacing: -0.015em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-336 {
        background: var(--buttons-all-platforms-btn-action-blue, #0060cc);
        border-radius: 5px 0px 0px 0px;
        padding: 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: absolute;
        right: 0px;
        bottom: 0px;
    }
    .active {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }
    .frame-1000011381 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: absolute;
        right: 15.67px;
        top: 16px;
    }
    .frame-313347 {
        flex-shrink: 0;
        width: 40px;
        height: 37px;
        position: relative;
    }
    .frame-29 {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .frame-29.disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
    .edit-01 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .check {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 42px;
        letter-spacing: -0.015em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-3362 {
        background: var(--buttons-all-platforms-btn-action-blue, #0060cc);
        border-radius: 5px 0px 0px 0px;
        padding: 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: absolute;
        right: -0.33px;
        bottom: 0px;
    }
    .frame-10000113812 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: absolute;
        right: 15.33px;
        top: 16px;
    }
    .edit-012 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .create {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 42px;
        letter-spacing: -0.015em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-3363 {
        background: var(--text-and-icons-red-500, #ff3636);
        border-radius: 5px 0px 0px 0px;
        padding: 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: absolute;
        right: -0.33px;
        bottom: 0px;
    }
    .missing {
        color: #ffffff;
        text-align: left;
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }
    .frame-10000113813 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: absolute;
        right: 16px;
        top: 16px;
    }
    .plus {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-176 {
        padding: 0px 300px 0px 300px;
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        width: 100%;
        position: relative;
    }
`;

/**
 * BOStageXCards Component
 * A styled card component used in the Product POS page.
 * @param {Object} props - Component properties
 * @param {string} props.title - The title of the card
 * @param {string} props.status - The status of the card
 * @param {string} props.type - The type of action (edit or add)
 * @param {function} props.onClick - Click handler for the card
 * @param {boolean} props.clickDisabled - Flag to disable click action
 * @returns {JSX.Element} Rendered card component
 * @description This component displays a card with a title, status, and an action icon (edit or add).
 *
 */
export default function BOStageXCards({ title, status, type, onClick, clickDisabled }) {
    const Icon = type === "edit" ? EditIcon : PlusIcon;

    /* #region METHODS */
    const getActionColor = () => {
        switch (status?.toUpperCase()) {
            case "ACTIVE":
                return "#0060cc";
            case "MISSING":
            case "UNKNOWN":
            case "SUSPENDED":
                return "#ff3636";
            case "TEST MISSING":
            case "INCOMPLETE":
            case "READY TO TEST":
                return "#FF0";
            default:
                return "#1e2631";
        }
    };

    const getActionTextColor = () => {
        if (status === "TEST MISSING" || status === "INCOMPLETE" || status === "READY TO TEST") return "#10141B";
        return "#d1d1d1"; // Default text color
    };
    /* #endregion */

    /* #region COMPUTED VARS */
    const actionColor = getActionColor();
    const actionTextColor = getActionTextColor();
    /* #endregion */

    return (
        <StyledBOStageXCards className="ui-card-style-01-m">
            <div className="frame-1000011380">
                <div className="get">{title}</div>
            </div>
            <div className="frame-336" style={{ backgroundColor: actionColor }}>
                <div className="active" style={{ color: actionTextColor }}>
                    {status}
                </div>
            </div>
            <div className="frame-1000011381">
                <div className="frame-313347">
                    <div
                        className={`frame-29 ${clickDisabled ? "disabled" : "cursor-pointer"}`}
                        onClick={!clickDisabled ? onClick : undefined}>
                        <Icon className="edit-01" />
                    </div>
                </div>
            </div>
        </StyledBOStageXCards>
    );
}

BOStageXCards.propTypes = {
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
};
